export default {
    commonObj: state => state.commonObj,
    orgList: state => state.orgList,
    orgComponentList: state => state.orgComponentList
  }
